import React from 'react';
import UserProfileReportTable from '../../components/UserProfileReportTable';

const AllUsersProfileReportTable = () => (
  <UserProfileReportTable
    endpoint="users"
    title="All User Profiles Report"
    exportName="All Users"
    emptyMessage="No Users found"
  />
);

export default AllUsersProfileReportTable;
